// eslint-disable-next-line import/no-cycle
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    user: null,
    token: null,
    refreshToken: null,
    refreshTokenExp: 0,
    // projects: [],
    exp: 0, // Token expiration time in seconds (UTC) from token
    roles: [],
    permissions: [],
    routeMeta: {},

    tv_code: null,

    projects_info: [],
    project_leads: [],
    jira_user: null,
    // activeProjectId: null,
    // activeIdentityId: null,
  };
};

const store = {
  namespaced: true,
  state: defaultState,
  getters: {
    user: (state) => state.user,
    tvCode: (state) => state.tv_code,
    isTv: (state) => !!state.tv_code,

    myProjects: (state) => state.projects_info.filter((p) => state.jira_user && p.project_lead_id === state.jira_user.id),

    token: (state) => state.token,
    refreshToken: (state) => state.refreshToken,

    tokenValid: (state) => (offsetSecs = 0) => state.token && (state.exp - offsetSecs > new Date().getTime() / 1000),
    refreshTokenValid: (state) => (offsetSecs = 0) => state.refreshToken && (state.refreshTokenExp - offsetSecs > new Date().getTime() / 1000),

    roles: (state) => state.roles,
    permissions: (state) => state.permissions,
    permissionsMap: (state) => state.permissions.reduce((m, p) => { m[p] = true; return m; }, {}),

    isLoggedIn: (state) => (state.exp > new Date().getTime() / 1000 || (state.refreshToken && state.refreshTokenExp.exp > new Date().getTime() / 1000)),
    // these are all projects (merged with admin)
    // projects: (state) => {
    //   return [
    //     ...state.projects.filter((e) => !state.user.projects.find((su) => su.id === e.id)),
    //     ...(state.user ? state.user.projects.map((s) => {
    //       s.role = s.project_users_current.length ? s.project_users_current[0].role : 'unknown';
    //       return s;
    //     }) : []),
    //     // ...state.projects.filter((e) => !state.user.project_users.find((sus) => sus.project_id === e.id)),
    //     // ...(state.user ? state.user.project_users.map((su) => { const s = su.project; s.role = su.role; return s; }) : []),
    //   ];
    // },
    // activeProject: (state, getters) => {
    //   if (!state.activeProjectId || !state.user || !state.user.projects) return null;
    //   return getters.projects.find((s) => s.id === state.activeProjectId);
    // },

    // // Active project identities
    // identities: (state, getters) => {
    //   return !getters.activeProject || !getters.activeProject.identities
    //     ? [] : getters.activeProject.identities;
    // },

    // // Active project identies
    // identity: (state, getters) => (id) => getters.identities.find((i) => i.id === id),

    // activeIdentity: (state, getters) => {
    //   return (!state.activeProjectId || !state.activeIdentityId) ? null
    //     : getters.identities.find((i) => i.id === state.activeIdentityId);
    // },

  },
  mutations,
  actions,
};

export { store, defaultState };
